import request from '@/utils/request';


export default {
    // 获取评分类型列表
    getApageList: (param) => {
        return request({
            url: `/appraise/AAA/pageList`,
            method: 'post',
            data: param
        });
    },
    // 获取评分类型列表
    getFacilityList: (param) => {
        return request({
            url: `/appraise/AAA/facilityList`,
            method: 'post',
            data: param
        });
    },
    // 获取评分类型列表
    getSponsorList: (param) => {
        return request({
            url: `/rmc/protein/asl/searchSponsorResource`,
            method: 'post',
            data: param
        });
    },
    // 评分任务删除
    deleteBatch: (param) => {
        return request({
            url: `/appraise/AAA/deleteBatch`,
            method: 'post',
            data: param
        });
    },
    // 保存评分任务
    saveFacilityList: (param) => {
        return request({
            url: `/appraise/AAA/generateBatchScore`,
            method: 'post',
            data: param
        });
    },
    // 评分任务详情
    getConditionList: (param,data) => {
        return request({
            url: `/appraise/AAA/${param}/conditionList`,
            method: 'post',
            data: data
        });
    },
    // 评分汇总分页查询
    getSummarPageList: (param,data) => {
        return request({
            url: `/appraise/AAA/summary/pageList`,
            method: 'post',
            data: data
        });
    },
    // AAA评分保存
    saveFinalScore: (param,id) => {
        return request({
            url: `/appraise/AAA/${id}/appraise`,
            method: 'post',
            data: param
        });
    },
    // AAA评分提交
    submitFinalScore: (id) => {
        return request({
            url: `/appraise/AAA/${id}/appraise/commit`,
            method: 'post',
        });
    },
    // 整改完成
    submitRectify: (id) => {
        return request({
            url: `/appraise/AAA/rectify/complete/${id}`,
            method: 'get',
        });
    },
    // 供应商整改
    supRectify: (id) => {
        return request({
            url: `/appraise/AAA/rectify/${id}`,
            method: 'get',
        });
    },
    // 整改详情页数据
    appraiseDetail: (id) => {
        return request({
            url: `/appraise/AAA/detail/${id}`,
            method: 'get',
        });
    },
    // 设置整改截止日期
    setExpire: (param) => {
        return request({
            url: `/appraise/AAA/rectify/setExpire`,
            method: 'post',
            data: param
        });
    },
}



